<div class="flex justify-end">
    @if (!isReadOnly()) {
        <bizz-search [searchTerm]="searchTerm" (searchTermChange)="searchTermChanged($event)">
        </bizz-search>
        <button type="button" (click)="addRecord()"
                class="save flex items-center justify-center px-2 py-1 sm:h-9">
                        <span class="flex items-center gap-2">
                            <bizz-icon class="size-4" iconName="circle-plus"></bizz-icon>
                        </span>
        </button>
    }
</div>
@if (!loading && (type == ChecklistAnswerClassType.Numeric || type == ChecklistAnswerClassType.SingleChoice)) {
    <bizz-grid
            [currentPage]="currentPage"
            [gridOptions]="gridOptions"
            [loading]="loading"
            [totalItems]="totalItems"
            [gridData]="pagedAndFiltered"
            [gridCellMetadata]="gridCellMetadata"
            [columnTemplate]="answerColumnTemplate"
            [commandColumnTemplate]="answerCommandColumnTemplate"
            (pageChange)="pageChanged($event)">
        <ng-template #answerColumnTemplate let-data let-column="column" let-columnIndex="columnIndex">
            @if (data.EditMode) {
                <bizz-checklist-edit-cell
                        [formGroup]="formGroup"
                        [id]="data.ID"
                        [data]="pagedAndFiltered"
                        [column]="column"
                        [(value)]="data[column.field]"
                        (valueChange)="onEditCellValueUpdated(data, column.field)"
                        [canShowNoneOption]="type == ChecklistAnswerClassType.Numeric"
                ></bizz-checklist-edit-cell>
            } @else {
                <bizz-grid-cell [data]="data" [gridColumn]="column" [metaData]="gridCellMetadata"
                                (onCellAction)="onCellAction($event)">
                </bizz-grid-cell>
            }
        </ng-template>

        <ng-template #answerCommandColumnTemplate let-data let-column="column" let-columnIndex="columnIndex">
            @if (!isReadOnly()) {
                <span class="flex w-fit pl-1 items-center gap-2 text-list-row-action">
                @if (data.EditMode) {
                    <span class="actions-cell-button" kendoTooltip [title]="'Edit' | translate">
                      <bizz-icon class="actions-cell-icon" (click)="changeEditMode(data, false)"
                                 iconName="circle-check"></bizz-icon>
                    </span>
                } @else {
                    <span class="actions-cell-button" kendoTooltip [title]="'Edit' | translate">
                      <bizz-icon class="actions-cell-icon" (click)="changeEditMode(data, true)"
                                 iconName="pencil"></bizz-icon>
                    </span>
                    <span class="actions-cell-button" kendoTooltip [title]="'Delete' | translate">
                      <bizz-icon class="actions-cell-icon hover:!text-red-500" iconName="trash-can"
                                 (click)="deleteRecord(data)"></bizz-icon>
                    </span>
                }
                </span>
            }
        </ng-template>

    </bizz-grid>
}